import { render, staticRenderFns } from "./TouristTaxPro.vue?vue&type=template&id=6443e901&scoped=true&"
import script from "./TouristTaxPro.vue?vue&type=script&lang=js&"
export * from "./TouristTaxPro.vue?vue&type=script&lang=js&"
import style0 from "./TouristTaxPro.vue?vue&type=style&index=0&id=6443e901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6443e901",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VForm,VIcon,VLayout})
